export const OVERVIEW_PERIOD = {
  last30: 'last_30',
  thisMonth: 'this_month',
  thisWeek: 'this_week',
}

export const OVERVIEW_PERIOD_LIST = [
  OVERVIEW_PERIOD.thisWeek,
  OVERVIEW_PERIOD.thisMonth,
  OVERVIEW_PERIOD.last30,
]

export const OVERVIEW_PERIOD_DEFAULT = OVERVIEW_PERIOD.thisWeek

export const QA_NAME_OVERVIEW_SYNC = 'rentalPortalOverviewSync'

export const OVERVIEW_PAYLOAD_FIELD = {
  awaitingApproval: 'awaiting_approval',
  awaitingApprovalTotal: 'awaiting_approval_total',
  communications: 'communications',
  communicationsTotal: 'communications_total',
  hasScope: 'has_scope',
  kpis: 'kpis',
  kpisDelta: 'kpis_delta',
  needsAttention: 'needs_attention',
  needsAttentionTotal: 'needs_attention_total',
  period: 'period',
  periodEnd: 'period_end',
  periodStart: 'period_start',
  scopeUserId: 'scope_user_id',
  upcomingViewings: 'upcoming_viewings',
  upcomingViewingsTotal: 'upcoming_viewings_total',
  weekEnd: 'week_end',
  weekStart: 'week_start',
}

export const OVERVIEW_KPI = {
  activeListings: 'active_listings',
  applicantsInScreening: 'applicants_in_screening',
  listingsClosed: 'listings_closed',
  newApplicants: 'new_applicants',
  viewingsThisWeek: 'viewings_this_week',
}

export const OVERVIEW_ATTENTION_TYPE = {
  newApplicants: 'new_applicants',
  portalError: 'portal_error',
  stale: 'stale',
  viewingOutcomeMissing: 'viewing_outcome_missing',
}

export const OVERVIEW_ATTENTION_SEVERITY = {
  amber: 'amber',
  neutral: 'neutral',
  red: 'red',
}

export const OVERVIEW_ATTENTION_REASON_KEY_BY_TYPE = {
  [OVERVIEW_ATTENTION_TYPE.newApplicants]:
    'RentalPortal.OverviewAttentionNewApplicantsKey',
  [OVERVIEW_ATTENTION_TYPE.portalError]:
    'RentalPortal.OverviewAttentionPortalErrorKey',
  [OVERVIEW_ATTENTION_TYPE.stale]: 'RentalPortal.OverviewAttentionStaleKey',
  [OVERVIEW_ATTENTION_TYPE.viewingOutcomeMissing]:
    'RentalPortal.OverviewAttentionViewingOutcomeMissingKey',
}
